import { getFunc, singlePostFunc, postFunc } from '@/services/index';

export const getSingle = customer_id => getFunc(`customer/${customer_id}`);
export const getAll = () => getFunc(`customers`);
export const update = payload => singlePostFunc(`customer/${payload.id}`, payload);
export const updatePhoto = (id, payload) => singlePostFunc(`user/${id}`, payload);